import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { leadSourceQueryKeys } from "./leadSourceQueryKeys";

export function useLeadSourceDisable({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (leadSourceId: number) => {
      await api.leadSourceApi.deactivate(leadSourceId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: leadSourceQueryKeys.all() });
    },
  });
}
